import { Button } from '@material-ui/core';
import React, { useState } from 'react';
import { ConfirmationDialog } from '../ConfirmationDialog/ConfirmationDialog';

interface Props {
  proceedAction: () => void;
  deviceNumber?: Nullable<string>;
  disabled?: boolean;
}

export const ResetButton: React.FC<Props> = ({ proceedAction, deviceNumber, disabled }) => {
  const [dialogVisible, setDialogVisible] = useState(false);

  const handleAction = (e: React.MouseEvent, openDialog: boolean) => {
    e.preventDefault();
    e.stopPropagation();
    setDialogVisible(openDialog);
  };

  return (
    <>
      <Button disabled={disabled} variant="contained" onClick={(e) => handleAction(e, true)}>
        Factory Reset
      </Button>
      <ConfirmationDialog
        open={dialogVisible}
        dialogText={`Are you sure you want to reset the device with UUID ${deviceNumber}?`}
        proceedEvent={(e) => {
          e.stopPropagation();
          proceedAction();
          setDialogVisible(false);
        }}
        closeEvent={(e) => handleAction(e, false)}
      />
    </>
  );
};
